import React, { useEffect } from 'react';
import { debounce } from 'utils/debounce';
import Icon from 'components/commons/icon/Icon';

export const GroupAdd = ({
  addGroup,
}: {
  addGroup: () => void;
}): React.ReactElement => {
  // 追従ボタンがstickyか否かでスタイルが異なるため対応、要共通化
  useEffect(() => {
    const addGroupScrollDebounce = debounce(() => {
      const addGroupBtnPosition = document
        .getElementById('addGroupBtn')
        ?.getBoundingClientRect().bottom;
      const viewHeight = window.innerHeight;
      if (addGroupBtnPosition === undefined) {
        return null;
      } else if (addGroupBtnPosition === viewHeight) {
        document
          .getElementById('addGroupBtn')
          ?.classList.add('bg-op-w80', 'shadow-fBtn');
      } else {
        document
          .getElementById('addGroupBtn')
          ?.classList.remove('bg-op-w80', 'shadow-fBtn');
      }
    }, 16);
    window.addEventListener('scroll', addGroupScrollDebounce, true);

    return () => {
      window.removeEventListener('scroll', addGroupScrollDebounce, true);
    };
  }, []);

  return (
    <>
      <div className="absolute left-1/2 blowing font-bold text-center py-2 px-4 border rounded-full text-bluegray-500 bg-white">
        グループ機能、どう使う？
      </div>
      <div className="border-b border-gray-300 pb-8 px-4">
        <div className="font-bold text-base text-teal-500 py-1 leading-6 text-center">
          活用例１
        </div>
        <div className="font-bold text-base py-1 leading-6 text-center">
          「家族」ごとに資産を分ける
        </div>
        <div className="text-xs leading-4.5 py-4">
          家族のメンバーごとに資産グループを作ることで、それぞれの資産状況を一元管理できます。「子供用の教育資金や貯金を把握しておきたい」という方にもおすすめです。
        </div>
        <div className="text-center">
          <img
            src="/static/images/home/katsuyo_1.png"
            width="345"
            height="200"
            className="lg:w-1/2 w-full img-inline p-4"
            alt="活用例1"
          />
        </div>
        <div className="font-bold text-gray-500 text-xs leading-4.5 text-center py-4">
          ＼ こんな人におすすめ！ ／
        </div>
        <div className="font-bold text-sm leading-5 text-center mb-2">
          家族の資産をまとめて管理したい人
        </div>
        <div className="h-1 w-64 bg-teal-600 right-half mx-auto"></div>
      </div>
      <div className="border-b border-gray-300 py-8 px-4">
        <div className="font-bold text-base text-teal-500 py-1 leading-6 text-center">
          活用例２
        </div>
        <div className="font-bold text-base py-1 leading-6 text-center">
          「目標」に合わせて資産を分ける
        </div>
        <div className="text-xs leading-4.5 py-4">
          「老後の資金」「マイホーム資金」など資産目標サポートで設定した目標に、作成した資産グループを登録することができます。目標にグループを登録すると達成するための提案を受けることができます。
        </div>
        <div className="text-center">
          <img
            src="/static/images/home/katsuyo_2.png"
            width="345"
            height="200"
            className="lg:w-1/2 w-full img-inline p-4"
            alt="活用例2"
          />
        </div>
        <div className="font-bold text-gray-500 text-xs leading-4.5 text-center py-4">
          ＼ こんな人におすすめ！ ／
        </div>
        <div className="font-bold text-sm leading-5 text-center mb-2">
          目標のために資産を増やしたい人
        </div>
        <div className="h-1 w-64 bg-teal-600 right-half mx-auto"></div>
      </div>
      <div className="border-b border-gray-300 py-8 px-4">
        <div className="font-bold text-base text-teal-500 py-1 leading-6 text-center">
          活用例３
        </div>
        <div className="font-bold text-base py-1 leading-6 text-center">
          「運用方法」に合わせて資産を分ける
        </div>
        <div className="text-xs leading-4.5 py-4">
          運用方法別にチャートやポートフォリオを確認することができます。例えば「積極的な投資」と「安全資産」で分けることで狙い通りの運用ができているか確認することができます。
        </div>
        <div className="text-center">
          <img
            src="/static/images/home/katsuyo_3.png"
            width="345"
            height="200"
            className="lg:w-1/2 w-full img-inline p-4"
            alt="活用例3"
          />
        </div>
        <div className="font-bold text-gray-500 text-xs leading-4.5 text-center py-4">
          ＼ こんな人におすすめ！ ／
        </div>
        <div className="font-bold text-sm leading-5 text-center mb-2">
          複数の運用資産を持っている人
        </div>
        <div className="h-1 w-64 bg-teal-600 right-half mx-auto"></div>
      </div>
      <div
        id="addGroupBtn"
        className="sticky z-10 bottom-0 py-4 bg-op-w80 shadow-fBtn"
        onClick={addGroup}>
        <div className="ui-btn px-3 mx-5 text-sm font-bold h-10 leading-10 cursor-pointer">
          <Icon name="plus" className="mr-1"></Icon>
          グループを追加する
        </div>
      </div>
    </>
  );
};
